import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, Drawer, List, ListItemButton, ListItemIcon, ListItemText, ThemeProvider, } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Link } from "react-router";
export const MobileNavbar = ({ open, onClose, homeItem, items, }) => {
    return (_jsxs(Drawer, { anchor: "right", open: open, onClose: onClose, slotProps: {
            paper: { sx: { width: (theme) => theme.Navbar.drawerWidth } },
        }, children: [_jsx(Box, { children: _jsx(DrawerNavItem, { item: homeItem, onClose: onClose }) }), _jsx(Divider, {}), _jsx(List, { sx: { py: 0 }, children: items.map((item) => (_jsx(DrawerNavItem, { item: item, onClose: onClose }, item.key))) })] }));
};
const DrawerNavItem = ({ item, onClose, }) => (_jsx(ThemeProvider, { theme: item.theme, children: _jsxs(ListItemButton, { component: Link, to: item.to, onClick: onClose, "aria-current": item.active ? "page" : undefined, sx: {
            gap: 1,
            py: 1.5,
            color: (theme) => theme.palette.primary.main,
            borderLeft: (theme) => theme.Navbar.MobileNavbar.selectedBorderLeft,
            borderLeftColor: (theme) => item.active ? theme.palette.primary.main : "transparent",
            backgroundColor: (theme) => item.active
                ? alpha(theme.palette.primary.main, theme.Navbar.MobileNavbar.selectedOpacity)
                : "transparent",
            "&:hover": {
                backgroundColor: (theme) => alpha(theme.palette.primary.main, theme.Navbar.MobileNavbar.hoverOpacity),
            },
            svg: { height: item.svgHeight ?? 30 },
        }, children: [_jsx(ListItemIcon, { sx: { minWidth: 0, color: "inherit" }, children: item.icon }), _jsx(ListItemText, { primary: item.label, slotProps: {
                    primary: {
                        sx: (theme) => theme.Navbar.typography,
                    },
                } })] }) }));
//# sourceMappingURL=MobileNavbar.js.map